import { render, staticRenderFns } from "./succession-tabs.vue?vue&type=template&id=5963a834&"
import script from "./succession-tabs.vue?vue&type=script&lang=js&"
export * from "./succession-tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports